module.exports = __webpack_public_path__ + "static/media/modiran.c4da2829.jpg";